
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((116|204|536)0|8682)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
